import { render, staticRenderFns } from "./content-hits-view.vue?vue&type=template&id=d61bf86a&scoped=true"
import script from "./content-hits-view.vue?vue&type=script&lang=js"
export * from "./content-hits-view.vue?vue&type=script&lang=js"
import style0 from "./content-hits-view.vue?vue&type=style&index=0&id=d61bf86a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61bf86a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d61bf86a')) {
      api.createRecord('d61bf86a', component.options)
    } else {
      api.reload('d61bf86a', component.options)
    }
    module.hot.accept("./content-hits-view.vue?vue&type=template&id=d61bf86a&scoped=true", function () {
      api.rerender('d61bf86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/analytics/content-hits-view.vue"
export default component.exports